// extracted by css-extract-rspack-plugin
export default {"avatar":"Code-module__avatar__k37wZ"};